export const responseMessage = {
  DEFAULT_ERROR: "에러가 발생했습니다.",
  LOGIN_FAIL: "로그인 후 다시 시도해주세요.",
  AUTH_FAIL: "토큰 인증 실패",
  PAGE_ERROR: "페이지에 에러가 발생했습니다.",
  TRY_AGAIN_LATER: "잠시 후에 다시 시도해주세요.",
  RELOAD: "다시 시도하기",
  ALLOW_ONLY_NUMBER: "숫자만 입력해주세요.",
  UNKNOWN_ERROR: "알 수 없는 에러가 발생했습니다.",
};

export const responseStatus = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};

export const USER_MANAGEMENT_PAGE_PATH = {
  LOGIN_IN: "/login",
  ROOT: "/",
};
